import { post } from 'axios';

export const updateSessionCartQuantity = (courseId, quantity) => {
    return post('cart/update', {
        headers: {'Content-Type': 'application/json'},
        data: {
            course_id: courseId, 
            quantity: quantity
        }
    });
};


export const removeFromSessionCart = (courseId) => {
    return post('cart/remove', {
        headers: {'Content-Type': 'application/json'},
        data: {
            course_id: courseId,
        }
    });
};